
const Constants = {
    timeLineEducationType: 'educationList',
    timelineworkExpType: 'workExpList',
    fresher: 'Fresher',
    experianced: 'Experianced',
    
    name: 'Ved Prakash',
    dob: '05/01/1996',
    phone: '8147068760',
    skypeId: 'abcprakash885',
    emailId: 'abcprakash885@gmail.com',
    linkedInUrl: 'https://www.linkedin.com/in/ved-prakash-a65634105',
    facebookUrl: 'https://www.facebook.com/imprakashved',
    gitHubUrl: 'https://github.com/thePrakashVed',
    profileUrl: 'https://firebasestorage.googleapis.com/v0/b/portfolio-53429.appspot.com/o/user.jpeg?alt=media&token=0f087be8-55cd-43db-9c78-a5505c45e083',
    isChat: true,
    isSuperAdmin: false,
    feedbackUrl: 'https://sheet.best/api/sheets/a3d62836-068b-49fd-a5fb-bfb4ba48e747',
    myInfo: '**Senior Software Engineer (Full-Stack)** with **10+ years of experience** building scalable, high-performance web and mobile applications using **React, Angular, Vue, and Node.js**. Proven track record of delivering enterprise-grade solutions for global clients like Apple and Mercedes-Benz, with strong expertise in **frontend architecture, system design, and performance optimization**.\n\nIn recent years, I have expanded my focus into **Artificial Intelligence and Generative AI**, actively working on **RAG (Retrieval-Augmented Generation) systems, Agentic AI, and AI-powered applications**. I specialize in designing and developing **intelligent AI agents** that can solve real-world problems, automate workflows, and deliver scalable, production-ready solutions. Additionally, I have built **AI-powered chatbots** using React and Node.js for intelligent user conversations and automation.\n\nI bring a **full product mindset**, capable of taking ideas from concept to deployment across **web, mobile, and cloud platforms**, while ensuring scalability, maintainability, and performance.',
    resumeLink: 'https://drive.google.com/file/d/1wI8B14YXvSi20qWWlQtG1oBN2uihv1Y4/view?usp=sharing',
    animatedHeadings: [
        'Engineering AI-Powered Solutions 🤖',
        'Creating Agentic AI Applications 🚀',
        'Developing Intelligent RAG Systems 📚',
        'Full-Stack Engineer Building AI Products ⚛️',
        'Crafting Modern Apps with React ⚛️',
        'Developing Dynamic UIs with Angular 🔺',
        'Creating Interactive Interfaces with Vue.js 🟩'
    ],
    typicalHeading: [
        'Engineering AI-Powered Solutions 🤖',
        'Creating Agentic AI Applications 🚀',
        'Developing Intelligent RAG Systems 📚',
        'Full-Stack Engineer Building AI Products ⚛️',
        'Frontend Developer 💻',
        'React Developer ⚛️',
        'Node.js Developer 🟢',
        'AI Chatbot Developer 💬',
        'RAG Specialist 📚',
        'Angular Developer 🔺',
        'Vue.js Developer 🟩',
        'PWA Developer 🌐',
        'Hybrid App Developer 📱'
    ],

    headerList: [
        {
            name: 'Resume',
            redirectTo: ''
        },
        {
            name: 'Portfolio',
            redirectTo: ''
        },
        {
            name: 'Contact',
            redirectTo: ''
        }
    ],
    educationList: [
        {
            name: 'S.D.M COLLEGE OF ENGINEERING AND TECHNOLOGIES, DHARWAD',
            cources: 'COMPUTER SCIENCE & ENGINEERING',
            acedomicYear: '2012-2016',
            grade: 'First Class With Distinction'
        },
        {
            name: 'Williams Senior Secondary School, Supaul',
            cources: 'Intermediate +2',
            acedomicYear: '2009-2011',
            grade: 'First Class'
        },
        {
            name: 'T. C HIGH SCHOOL CHAKALA NIRMALI, SUPAUL',
            cources: '10th',
            acedomicYear: '2008-2009',
            grade: 'First Class'
        }
    ],
    workExpList: [
        {
            name: 'Quest Global, Bangalore',
            acedomicYear: 'Jan-2023 to Present',
            designation: 'Sr. Software Engineer'
        },
        {
            name: 'Wunderman Thompson Commerce, Noida',
            acedomicYear: 'Aug-2021 to Jan-2023',
            designation: 'Software Engineer'
        },
        {
            name: 'Robosoft Technologies, Udupi',
            acedomicYear: 'June-2016 to Aug-2021',
            designation: 'Software Engineer'
        }
    ],
    technicalSkillsList: [
        {
            skillType: 'Frameworks',
            skillsList: [
                {
                    name: 'Angular',
                    rating: 9
                },
                {
                    name: 'VueJs',
                    rating: 6
                },
                {
                    name: 'React Js',
                    rating: 6
                }
            ]
        },
        {
            skillType: 'Scripting Technologies',
            skillsList: [
                {
                    name: 'HTML',
                    rating: 9
                },
                {
                    name: 'CSS/Scss',
                    rating: 9
                },
                {
                    name: 'Bootstrap',
                    rating: 8
                },
                {
                    name: 'Java Script',
                    rating: 9
                },
                {
                    name: 'Type Script',
                    rating: 9
                },
                {
                    name: 'PWA',
                    rating: 9
                },
                {
                    name: 'JQuery',
                    rating: 9
                },
                {
                    name: 'ES6',
                    rating: 9
                }
            ]
        },
        {
            skillType: 'Hybrid Mobile app development Frameworks',
            skillsList: [
                {
                    name: 'Cordova',
                    rating: 8
                },
                {
                    name: 'IBM Worklight',
                    rating: 6
                }
            ]
        },
        {
            skillType: 'Build tools',
            skillsList: [
                {
                    name: 'Jenkins',
                    rating: 10
                },
                {
                    name: 'Hudson',
                    rating: 10
                }
            ]
        },
        {
            skillType: 'Development tools',
            skillsList: [
                {
                    name: 'Git',
                    rating: 10
                },
                {
                    name: 'Tortoise SVN',
                    rating: 10
                },
                {
                    name: 'JIRA',
                    rating: 10
                },
                {
                    name: 'FILE ZILLA',
                    rating: 10
                },
                {
                    name: 'VS Code',
                    rating: 10
                },
                {
                    name: 'Android Studio',
                    rating: 10
                },
                {
                    name: 'Xcode',
                    rating: 10
                }
            ]
        },
        {
            skillType: 'AI & Generative AI',
            skillsList: [
                {
                    name: 'Generative AI',
                    rating: 9
                },
                {
                    name: 'RAG Systems',
                    rating: 9
                },
                {
                    name: 'Agentic AI',
                    rating: 8
                },
                {
                    name: 'Chatbot Development',
                    rating: 8
                },
                {
                    name: 'LLM Integration',
                    rating: 8
                },
                {
                    name: 'Prompt Engineering',
                    rating: 8
                }
            ]
        },
        {
            skillType: 'DevOps & Cloud',
            skillsList: [
                {
                    name: 'AWS S3',
                    rating: 9
                },
                {
                    name: 'AWS Lambda',
                    rating: 9
                },
                {
                    name: 'AWS API Gateway',
                    rating: 9
                },
                {
                    name: 'AWS SES',
                    rating: 8
                },
                {
                    name: 'AWS CloudFront',
                    rating: 8
                },
                {
                    name: 'AWS Bedrock',
                    rating: 8
                },
                {
                    name: 'Docker',
                    rating: 8
                },
                {
                    name: 'CI/CD Pipelines',
                    rating: 8
                }
            ]
        }
    ],
    projectList: [
        {
            clientName: 'Glanbia - Body and Fit',
            description: 'High-performance e-commerce platform for nutrition products. Built with Angular and TypeScript, featuring advanced filtering, dynamic product catalog, and seamless checkout experience. Achieved 40% improvement in conversion rates through optimized UX design and performance enhancements.',
            technologies: ['Angular', 'HTML', 'SCSS', 'TypeScript', 'Jest', 'JSP']
        },
        {
            clientName: 'NewLook',
            description: 'Modern fashion e-commerce web application serving millions of users. Developed with Vue.js and responsive design, featuring real-time inventory management, personalized recommendations, and intuitive user interface with sub-100ms load times.',
            technologies: ['VueJs', 'HTML', 'SCSS', 'TypeScript', 'Jest', 'JSP']
        },
        {
            clientName: 'Paypay- P2P',
            description: 'Japanese peer-to-peer payment mini-app enabling users to chat and transfer money seamlessly. Engineered with Vue.js and ElementUI, featuring real-time messaging, transaction tracking, and secure payment integration comparable to Google Pay and PhonePe.',
            technologies: ['VueJs', 'HTML', 'SCSS', 'TypeScript', 'ElementUI']
        },
        {
            clientName: 'Paypay- MP/MPA',
            description: 'Comprehensive merchant management platform for Japanese-based PayPay ecosystem. Developed using Vue.js with ElementUI components, enabling merchants to create and manage stores, process payments, and track analytics with enterprise-grade security and scalability.',
            technologies: ['VueJs', 'HTML', 'SCSS', 'TypeScript', 'Jest', 'ElementUI']
        },
        {
            clientName: 'Airsewa',
            description: 'Government of India\'s initiative by Ministry of Civil Aviation for airport grievance resolution. Built a comprehensive PWA and mobile app using Angular and Cordova, enabling users to log grievances, view airport facilities, order food, and track flight information with real-time updates.',
            technologies: ['Angular', 'HTML', 'SCSS', 'TypeScript', 'Bootstrap', 'Cordova', 'PWA']
        },
        {
            clientName: 'Mercedes-Benz',
            description: 'Innovative repair center management system for Mercedes dealerships. Allows mechanics to update vehicle issue status in real-time, enabling car owners to track repairs and pickup schedules. Developed with Angular for intuitive UI and robust backend integration.',
            technologies: ['Angular', 'HTML', 'SCSS', 'TypeScript', 'Bootstrap']
        },
        {
            clientName: 'Lakshmi Vilas Bank',
            description: 'Enterprise banking application enabling secure fund transfers via RTGS, NEFT, and IMPS protocols. Developed with Angular and IBM Worklight with Cordova for cross-platform mobile support, featuring account management, card details view, and banking security compliance.',
            technologies: ['Angular', 'HTML', 'SCSS', 'TypeScript', 'Bootstrap', 'IBM Worklight', 'Cordova']
        },
        {
            clientName: 'South Indian Bank',
            description: 'Full-featured banking platform supporting digital financial transactions and account management. Built with Angular framework for enterprise reliability, featuring RTGS/NEFT/IMPS transfers, multi-account support, card management, and mobile-first responsive design with Cordova integration.',
            technologies: ['Angular', 'HTML', 'SCSS', 'TypeScript', 'Bootstrap', 'IBM Worklight', 'Cordova']
        },
        {
            clientName: 'AI-Powered Chatbot',
            description: 'Intelligent conversational AI chatbot built with React frontend and Node.js backend. Integrates advanced NLP, context-aware responses, and real-time conversation tracking. Deployed with chat history persistence and markdown-based response rendering for rich user interactions.',
            technologies: ['React', 'Node.js', 'TypeScript', 'React-Markdown', 'APIs']
        },
        {
            clientName: 'AWS Email Automation Portal',
            description: 'Serverless website built with AWS infrastructure enabling client customer inquiries for product and sales information. Architected with S3 for static hosting, CloudFront for secure HTTPS delivery and CDN acceleration, API Gateway for request routing, Lambda functions for backend logic, and AWS SES for automated email distribution to sales@domain.com and contact@domain.com. Seamlessly triggers email notifications when customers submit inquiry forms, ensuring instant notification to the sales team.',
            technologies: ['AWS S3', 'AWS Lambda', 'AWS API Gateway', 'AWS SES', 'AWS CloudFront', 'HTML', 'CSS', 'JavaScript']
        }
    ]
}

export default Constants;